// extracted by mini-css-extract-plugin
module.exports = {"label":"Radio_label__bVGXQ","input":"Radio_input__s1bKA","control":"Radio_control__ojyBb","outline":"Radio_outline__RIPtr","active":"Radio_active__Ls78V"};